import React, { useEffect, useState } from "react";
import JoditEditor from "jodit-react";
import { toast } from 'react-toastify';
import axios from "axios";
import "../../App.css";
import { ApiUrl } from '../../Constants/Weburl'
import joditConfig from "../../components/config/joditconfig";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";
import CustomButton from "../../components/CustomButton";;

const PUBLIC_POLICY_URL = `${ApiUrl}api/privacy-policy`;



export default function Privacy() {

  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);


  const adminToken = localStorage.getItem("adminToken");

  console.log('adminToken', adminToken);

  useEffect(() => {
    const fetchPolicy = async () => {
      try {
        const res = await axios.get(`${ApiUrl}api/getprivacypolicy`, 
          {
          headers: { Authorization: `Bearer ${adminToken}` }
        });
        setContent(res.data?.data?.content || "");
      } catch (err) {
        toast.error("Failed to load privacy policy");
      } finally {
        setLoading(false);
      }
    };
    fetchPolicy();
  }, []);

  const handleSave = async () => {
    if (!content.trim()) {
      toast.error("Content cannot be empty");
      return;
    }
    try {
      setSaving(true);
      await axios.put(`${ApiUrl}api/saveprivacypolicy`, { content }, {
        headers: {
          Authorization: `Bearer ${adminToken}`
        }
      });
      toast.success("Privacy policy saved");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Layout>
        <SettingsPageShell
          title="Privacy Policy"
          headerRight={
            <button
              className="ls-save-btn"
                onClick={() => window.open(PUBLIC_POLICY_URL, "_blank")}

            >
              View
            </button>
          }
        >



          <div className="ls-card">
            {!loading && (
              <JoditEditor
                value={content}
                config={joditConfig}
                onBlur={(newContent) => {
                  setContent(newContent);
                }}
              />
            )}

            <CustomButton
              type="button"
              className="ls-save-btn"
              onClick={handleSave}
              disabled={saving || loading}
            >
              {saving ? "Saving" : "Save"}
            </CustomButton>

          </div>








        </SettingsPageShell>

      </Layout>
    </>
  );
}


